// componentsMap.js

// ✅ Core imports
import AllHtmlComponents from "./All Tutorial page/HTML/AllHtmlComponents";
import AllCssComponents from "./All Tutorial page/CSS_component/AllCssComponents";
import AllColorsComponents from "./All Tutorial page/colors_components/AllColorsComponents";
import AllPythonComponents from "./All Tutorial page/python_all_components/AllPythonComponents";
import AllJavaComponents from "./All Tutorial page/java_all_components/AllJavaComponents";
import AllJavascriptComponents from "./All Tutorial page/JavaScript/AllJavascriptComponents";
import AllCProgrammingComponents from "./All Tutorial page/c_components/AllCProgrammingComponents";
import cppComponentsMap from "./All Tutorial page/cpp_components/AllCppComponents";
import csharpComponentsMap from "./All Tutorial page/CSharp/AllCsharpComponents";
import AllBashComponents from "./All Tutorial page/bash_components/AllBashComponents";
import AllPHPComponents from "./All Tutorial page/php_exact_components (1)/AllPHPComponents";
import AllReactComponents from "./All Tutorial page/react_all_components/AllReactComponents";
import AllRComponents from "./All Tutorial page/r_all_components/AllRComponents";
import AllRustComponents from "./All Tutorial page/rust_components/AllRustComponents";
import AllNumpyComponents from "./All Tutorial page/numpy_components/AllNumpyComponents";
import AllPandasComponents from "./All Tutorial page/pandas_components/AllPandasComponents";
import AllExcelComponents from "./All Tutorial page/excel_components/AllExcelComponents";
import AllDjangoComponents from "./All Tutorial page/django_components/AllDjangoComponents";
import AllDataScienceComponents from "./All Tutorial page/data_science_components/AllDataScienceComponents";
import AllCyberSecurityComponents from "./All Tutorial page/cyber_security_components/AllCyberSecurityComponents";
import AllDSAComponents from "./All Tutorial page/dsa_components/AllDSAComponents";
import AllSassComponents from "./All Tutorial page/sass_components/AllSassComponents";
import AllAwsComponents from "./All Tutorial page/aws_components/AllAwsComponents";
import AllAppmlTutorialComponents from "./All Tutorial page/appml_tutorial_components/AllAppmlTutorialComponents";
import AllAspTutorialComponents from "./All Tutorial page/asp_tutorial_components/AllAspTutorialComponents";
import AllAiPromptComponents from "./All Tutorial page/ai_prompt_components/AllAiPromptComponents";
import AllAIComponents from "./All Tutorial page/AI_Components/AllAIComponents";
import jsonJsComponentsMap from "./All Tutorial page/JavaScript/jsonJsComponentsMap";
// ✅ Framework + libs
import chatgptComponentsMap from "./All Tutorial page/chatgpt_components/AllChatGPTComponents";
import bardComponentsMap from "./All Tutorial page/bard_components/AllBardComponents";
import bootstrap3ComponentsMap from "./All Tutorial page/Bootstrap3_Components/AllBootstrap3Components";
import bootstrap4ComponentsMap from "./All Tutorial page/bootstrap4_components/AllBootstrap4Components";
import bootstrap5ComponentsMap from "./All Tutorial page/Bootstrap5_Components/AllBootstrap5Components";
import canvasComponentsMap from "./All Tutorial page/canvas_components/AllCanvasComponents";
import gsComponentsMap from "./All Tutorial page/gs_components/GsComponentsMap";
import iconsComponentsMap from "./All Tutorial page/icons_components/iconsComponentsMap";
import jqueryComponentsMap from "./All Tutorial page/jquery_components/jquery_components";
import jsAjaxComponentsMap from "./All Tutorial page/JavaScript/js_ajax_components_map";

// ✅ Languages + ML
import kotlinComponentsMap from "./All Tutorial page/kotlin_components/kotlin_components_map";
import machinelearningComponentsMap from "./All Tutorial page/machinelearning_components/machinelearningComponentsMap";
import matplotlibComponentsMap from "./All Tutorial page/matplotlib_components/MatplotlibComponentsMap";
import MongoDBComponentsMap from "./All Tutorial page/mongodb_components/MongoDBComponentsMap";
import MySQLComponentsMap from "./All Tutorial page/mysql_components/MySQLComponentsMap";
import NodejsComponentsMap from "./All Tutorial page/nodejs_components/NodejsComponentsMap";
import scipyComponentsMap from "./All Tutorial page/scipy_components/AllScipyComponents";
import SQLComponentsMap from "./All Tutorial page/sql_all_components_complete/SQLComponentsMap";
import StatisticsComponentsMap from "./All Tutorial page/statistics_components/StatisticsComponentsMap";
import typeScriptComponentsMap from "./All Tutorial page/typescript_components/TypeScriptComponentsMap";
import vueComponentsMap from "./All Tutorial page/vue_components/VueComponentsMap";
import webComponentsMap from "./All Tutorial page/web_components/WebComponentsMap";
import xmlComponentsMap from "./All Tutorial page/XML_components/XmlComponentsMap";

// ✅ Other
import graphicsComponentsMap from "./All Tutorial page/graphics_components/AllGraphicsComponents";
import AllGoComponents from "./All Tutorial page/go_com/AllGoComponents";
import AllGitComponents from "./All Tutorial page/git_components/AllGitComponents";

// ✅ Master Map
const componentsMap = {
  HTML: AllHtmlComponents,
  CSS: AllCssComponents,
  Python: AllPythonComponents,
  Java: AllJavaComponents,
  JavaScript: AllJavascriptComponents,
  Cprograming: AllCProgrammingComponents,
  Colors: AllColorsComponents,
  CPlusPlus: cppComponentsMap,
  CSharp: csharpComponentsMap,
  Bash: AllBashComponents,
  PHP: AllPHPComponents,
  React: AllReactComponents,
  R: AllRComponents,
  Rust: AllRustComponents,
  NumPy: AllNumpyComponents,
  Pandas: AllPandasComponents,
  Excel: AllExcelComponents,
  Django: AllDjangoComponents,
  DataScience: AllDataScienceComponents,
  CyberSecurity: AllCyberSecurityComponents,
  DSA: AllDSAComponents,
  Sass: AllSassComponents,
  AWS: AllAwsComponents,
  AppML: AllAppmlTutorialComponents,
  ASP: AllAspTutorialComponents,
  AiPrompt: AllAiPromptComponents,
  AI: AllAIComponents,
  ChatGPT: chatgptComponentsMap,
  Bard: bardComponentsMap,
  Bootstrap3: bootstrap3ComponentsMap,
  Bootstrap4: bootstrap4ComponentsMap,
  Bootstrap5: bootstrap5ComponentsMap,
  Canva: canvasComponentsMap,
  Googlesheets: gsComponentsMap,
  Icons: iconsComponentsMap,
  jQuery: jqueryComponentsMap,
  Json: jsonJsComponentsMap,
  Ajax: jsAjaxComponentsMap,
  Kotlin: kotlinComponentsMap,
  Machinelearning: machinelearningComponentsMap,
  Matplotlib: matplotlibComponentsMap,
  MongoDB: MongoDBComponentsMap,
  MySQL: MySQLComponentsMap,
  Nodejs: NodejsComponentsMap,
  SciPY: scipyComponentsMap,
  SQL: SQLComponentsMap,
  Statistics: StatisticsComponentsMap,
  TypeScript: typeScriptComponentsMap,
  Vue: vueComponentsMap,
  WebDevelopment: webComponentsMap,
  XML: xmlComponentsMap,
  Grabhics: graphicsComponentsMap,
  Go: AllGoComponents,
  Git: AllGitComponents,
};

export default componentsMap;
